<template>
  <div class="w-full shadow rounded-lg mb-3 border-gray-400 border-none">
    <div class="px-3 py-3 w-full bg-gray-100 rounded-t-lg text-gray-900 border-gray-400 border-b">
      <div class="flex items-center justify-between relative">
        <div class="flex-col items-center justify-start">
          <div class="text-sm md:text-base font-medium">
            Menunggu Pembayaran
          </div>
          <div class="text-2xs text-gray-600 mt-1">
            {{ $moment(transaction.updated_at) | moment('D MMM Y') }}
          </div>
        </div>
        <button
          class="focus:outline-none active:bg-transparent"
          @click.stop="openMore()">
          <svg
            class="rotate-90 fill-current w-6 h-6"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"><path d="M296 136c0-22.002-17.998-40-40-40s-40 17.998-40 40 17.998 40 40 40 40-17.998 40-40zm0 240c0-22.002-17.998-40-40-40s-40 17.998-40 40 17.998 40 40 40 40-17.998 40-40zm0-120c0-22.002-17.998-40-40-40s-40 17.998-40 40 17.998 40 40 40 40-17.998 40-40z" /></svg>
        </button>
        <button
          v-if="moreOpen && $store.state.dropdownOpen"
          :disabled="$store.state.loading"
          class="absolute bg-gray-100 mt-6 right-0 top-0 rounded-sm border border-gray-200 py-3 px-5 shadow text-sm md:text-base active:shadow-none focus:outline-none"
          @click="cancelTransaction()">
          Batalkan Transaksi
        </button>
      </div>
    </div>
    <div class=" px-3 pt-3 pb-1 w-full bg-gray-100 text-gray-900">
      <div class="flex-col items-start justify-start mb-5">
        <div class="mb-2 text-xs text-gray-600">
          Total
        </div>
        <div class=" md:text-base font-medium text-orange-600">
          {{ $rupiah(transaction.total_price) }}
        </div>
      </div>
      <template v-if="transaction.payment_type">
        <div
          v-if="transaction.payment_type == 'echannel'"
          class="flex-col items-start justify-start mb-5">
          <div class="mb-2 text-xs text-gray-600">
            Kode Perusahaan
          </div>
          <div class=" md:text-base">
            {{ transaction.payment_company_code }}
          </div>
        </div>
        <div
          v-if="transaction.payment_type == 'cstore'"
          class="flex-col items-start justify-start mb-5">
          <div class="mb-2 text-xs text-gray-600">
            Kode Pembayaran
          </div>
          <div class=" md:text-base">
            {{ transaction.payment_bill_number }}
          </div>
        </div>
        <div
          v-if="transaction.payment_type == 'bank_transfer' || transaction.payment_type == 'echannel'"
          class="flex-col items-start justify-start mb-5">
          <div
            v-if="transaction.payment_type == 'bank_transfer'"
            class="mb-2 text-xs text-gray-600">
            Nomor Virtual Account
          </div>
          <div
            v-if="transaction.payment_type == 'echannel'"
            class="mb-2 text-xs text-gray-600">
            Kode Pembayaran
          </div>
          <div class=" md:text-base">
            {{ transaction.payment_bill_number }}
          </div>
        </div>
        <div
          class="flex-col items-start justify-start mb-5"
          :class="{ '-mb-px': transaction.payment_type == 'gopay' }">
          <div class="mb-2 text-xs text-gray-600">
            Metode Pembayaran
          </div>
          <div class="text-sm md:text-base">
            {{ transaction.payment_method }}
          </div>
        </div>
      </template>
    </div>
    <div class="rounded-b-lg  bg-green-600 text-center text-white font-bold md:text-lg">
      <div
        v-if="transaction.payment_type == 'gopay'"
        class="rounded-b-lg w-full h-full bg-gray-100">
&nbsp;
      </div>
      <button
        v-if="transaction.payment_type == null"
        class="font-bold rounded-b-lg p-3 w-full h-full focus:outline-none active:bg-green-500 disabled:bg-green-500 disabled:cursor-not-allowed disabled:opacity-75"
        :disabled="$store.state.loading"
        @click="openPaymentGateway()">
        Pilih Pembayaran
      </button>
      <button
        v-if="transaction.payment_type != null && transaction.payment_type != 'gopay'"
        class="font-bold rounded-b-lg p-3 w-full h-full focus:outline-none active:bg-green-500 disabled:bg-green-500 disabled:cursor-not-allowed disabled:opacity-75"
        :disabled="$store.state.loading"
        @click="openPaymentGateway()">
        Lanjutkan Pembayaran
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      validator: (val) => true,
      default: null,
    }
  },
  data() {
    return {
      moreOpen: false,
    };
  },
  computed: {
    dropdownOpen () {
      return this.$store.state.dropdownOpen;
    },
    transaction() {
      return this.$store.getters.pendingTransactionById(this.id);
    },
  },
  watch: {
    dropdownOpen(dropdownOpenValue) {
      if (dropdownOpenValue == false && this.moreOpen == true)  {
        this.moreOpen = false;
      }
    },
  },
  mounted() {
    this.$nextTick(function () {
      // this.$store.commit('setCurrentPath', '');
    })
  },
  methods: {
    async cancelTransaction() {
      this.$store.commit('setLoading', true);
      try {
        await this.$store.dispatch('pushDeleteTransactionById', this.id);
        this.$store.commit('deletePendingTransactionById', this.id);
      } catch (error) {
        this.$store.commit('setLoading', false);
        throw error;
      }
      this.$store.commit('setLoading', false);
    },
    async openPaymentGateway() {
      this.$store.commit('setLoading', true);
      if (this.transaction.redirect_url != null) {
        window.location.href = this.transaction.redirect_url;
      } else {
        let response = await axios.post('/continue-transaction', {id: this.transaction.id});
        window.location.href = response.data;
      }
      this.$store.commit('setLoading', false);
    },
    openMore() {
      this.moreOpen = !this.moreOpen;
      this.$store.commit('setDropdownOpen', this.moreOpen);
    }
  },
}
</script>
